import { Controller } from "@hotwired/stimulus"

// Het deelmenu van de telefoon, en op een laptop zonder deelmenu kopiëren.
export default class extends Controller {
  static values = { text: String }
  static targets = ["status"]

  async share() {
    if (navigator.share) {
      try {
        await navigator.share({ text: this.textValue })
        return
      } catch (error) {
        if (error.name === "AbortError") return
      }
    }
    this.copy()
  }

  async copy(event) {
    try {
      await navigator.clipboard.writeText(event?.params?.text || this.textValue)
      this.say(this.element.dataset.copiedLabel)
    } catch {
      this.say(this.element.dataset.copyFailedLabel)
    }
  }

  say(message) {
    if (!this.hasStatusTarget || !message) return

    this.statusTarget.textContent = message
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => { this.statusTarget.textContent = "" }, 3000)
  }
}
